<template lang="pug">
  .register-form
    .register-form-header
      h2
        span.primary-text Sign Up

    form(@keyup.enter="submit", @submit.prevent="submit")
      div.form-field(:class="{error: $v.form.firstName.$error, 'error-required': !$v.form.firstName.required}")
        label
          h6 First Name
          input(placeholder="First Name", type="text", minlength="2", maxlength="25", v-model="$v.form.firstName.$model")

      div.form-field(:class="{error: $v.form.lastName.$error, 'error-required': !$v.form.lastName.required}")
        label
          h6 Last Name
          input(placeholder="Last Name", type="text", minlength="2", maxlength="25", v-model="$v.form.lastName.$model")

      div.form-field(:class="{error: $v.form.email.$error || errors.email, 'error-required': !$v.form.email.required}")
        label
          h6 Email Address
          input(placeholder="Email Address", v-model="$v.form.email.$model", type="email")
        .error(v-if="errors.email") {{ errors.email }}

      div.form-field(:class="{error: $v.form.password.$error, 'error-required': !$v.form.password.required}")
        label
          h6 Password
          input(placeholder="Password", minlength="8", v-model="$v.form.password.$model", type="password")

      div.form-field
        button.button.primary-button(type="submit") Register

    p.footer
      | Already have an account?
      a(@click="login") Login!

</template>

<script>

import { required } from 'vuelidate/lib/validators'


export default {
  name: 'RegisterForm',
  components: {
  },
  props: {
  },
  data () {
    return {
      form: {
        firstName: '',
        lastName: '',
        email: '',
        password: ''
      },
      errors: {}
    }
  },
  validations: {
    form: {
      firstName: {
        required
      },
      lastName: {
        required
      },
      email: {
        required
      },
      password: {
        required
      }
    }
  },

  methods: {
    login () {
      this.$emit('swap', 'LoginForm')
    },
    submit () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        console.log('invalid')
      } else {
        this.$store.dispatch('user/register', this.form).then(() => {
          this.$router.push({ name: 'Verify' })
        }, response => {
          this.errors = response.data.errors
        })
      }
    }
  }
}
</script>

<style scoped lang="stylus">
  .register-form
    padding $spacing-3
    min-width 400px
    +for_breakpoint(mobile)
      min-width auto
    .register-form-header
      margin-bottom $spacing-3

    p.footer
      text-align center
      a
        cursor pointer
        margin-left 5px
        text-decoration underline
</style>
